import React from "react"
import { ContentBox } from '@portal/kit/pkg/components'
import { dateToLocaleString } from 'helpers/date'
import { useTheme } from "react-jss"
import { useTranslation } from "react-i18next"
import classNames from 'classnames'

import styles from './styles'

export default function RunningTickets({ runningTickets }) {
  const theme = useTheme()
  const { t, i18n } = useTranslation()
  const classes = styles(theme)

  return runningTickets.map(ticket => {
    const duration = t(`internet_access.duration.${ticket.duration_unit}`, { count: ticket.duration_amount })
    const accessTypeKey = ticket.duration_unit === 'unlimited' ? 'unlimited' : 'other'
    const end_date = dateToLocaleString({ date: ticket.end_date, language: i18n.language })

    return (
      <ContentBox title={t('internet_access.my_internet_access')} titleIcon="wifi" key={ticket.id}>
        <p className={classes.internetAccessText}>
          <span className={classNames('fal', 'fa-tachometer-alt-fastest', classes.internetAccessIcon)} />
          <span dangerouslySetInnerHTML={{ __html: t(`internet_access.description`, { duration, end_date }) }} />
        </p>
        <p className={classes.internetAccessText}>
          <span className={classNames('fal', 'fa-phone-laptop', classes.internetAccessIcon)} />
          <span dangerouslySetInnerHTML={{ __html: t(`internet_access.your_access_type.${accessTypeKey}`, { duration, end_date }) }} />
        </p>
      </ContentBox>
    )
  })
}
